import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';

export default function AuthPage() {
  const { login } = useAuth();
  const [form, setForm] = useState({ login: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          login: form.login.trim(),
          password: form.password
        }),
      });

      const data = await res.json();

      if (res.ok) {
        login(data.token);
        setSuccess('Вход успешен! Перенаправление...');
        setTimeout(() => {
          window.location.href = '/profile';
        }, 1500);
      } else {
        setError(data.message || 'Неизвестная ошибка сервера');
      }
    } catch (err) {
      console.error('Ошибка сети:', err);
      setError('Нет соединения с сервером. Проверьте backend');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1b1b1b] text-[#dedede] font-['Inter',sans-serif] antialiased overflow-x-hidden">
      <Header />

      <section className="py-24 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-8">
          <div className="glass-panel rounded-[28px] p-8 md:p-12 max-w-md mx-auto shadow-[0_0_60px_rgba(184,151,90,0.15)]">
            <h2 className="text-4xl md:text-5xl font-black uppercase text-center mb-12 tracking-tighter">
              Вход в аккаунт
            </h2>

            <form onSubmit={handleSubmit} className="space-y-8">
              <input
                type="text"
                placeholder="Email / Телефон / ФИО"
                value={form.login}
                onChange={(e) => setForm({ ...form, login: e.target.value })}
                className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-full backdrop-blur-md text-[#dedede] placeholder-slate-400 focus:border-primary focus:outline-none disabled:opacity-50"
                required
                disabled={loading}
              />

              <input
                type="password"
                placeholder="Пароль"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-full backdrop-blur-md text-[#dedede] placeholder-slate-400 focus:border-primary focus:outline-none disabled:opacity-50"
                required
                disabled={loading}
              />

              <button
                type="submit"
                disabled={loading}
                className="w-full px-10 py-5 bg-primary text-white font-black rounded-full neon-glow-red uppercase tracking-widest text-sm hover:shadow-[0_0_50px_rgba(225,29,72,0.5)] transition-all disabled:opacity-50"
              >
                {loading ? 'Вход...' : 'Войти'}
              </button>
            </form>

            {error && (
              <p className="text-center mt-8 text-red-500 font-medium">
                Ошибка: {error}
              </p>
            )}

            {success && (
              <p className="text-center mt-8 text-green-500 font-medium">
                {success}
              </p>
            )}

            <p className="text-center mt-8 text-slate-400 text-sm">
              Нет аккаунта? Обратитесь в офис автошколы.
            </p>
          </div>
        </div>
      </section>

      <BottomNav />
    </div>
  );
}